import { useApolloClient } from '@apollo/client'
import { useCalendarData as useZionCalendarData } from '@fs/zion-rootstech'
import useCalendarImageSizes from './useCalendarImageSizes'
import { useErrorHandlerOverlay } from '../../../hooks'

/**
 * App adapter over Zion's useCalendarData.
 *
 * Zion owns the query and the stage-flattening; this supplies the app-specific pieces it
 * takes as props instead of reading itself — the CAE Apollo client, the bandwidth-aware
 * image sizes — and re-attaches the error overlay Zion hands back to the caller.
 */
export default function useCalendarData(options) {
  // Support both string argument (legacy) and object argument (current)
  // useCalendarData('main-stage') -> { calendarType: 'main-stage', skip: false }
  // useCalendarData({ calendarType: 'sessions', skip: true }) -> unchanged
  const { calendarType, skip = false } =
    typeof options === 'string' ? { calendarType: options, skip: false } : options || {}

  // The CAE client is the default Apollo client (see zion's ApolloProviders), so this is the
  // same client useLoggedQuery's useQuery resolved from context.
  const client = useApolloClient()
  const imageSizes = useCalendarImageSizes()

  const { loading, data, error } = useZionCalendarData({ client, calendarType, imageSizes, skip })
  useErrorHandlerOverlay(error)

  return { loading, data, error }
}
